import type { BundledOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import { isBundleAndSaveV2Enabled } from 'lib/offer/offerUtils'
import moment from 'moment'
import { useCallback } from 'react'

interface ReturnArgs {
  isComplementaryBundleCell: (day: App.CalendarDay) => boolean
  isComplementaryCheckInCell: (day: App.CalendarDay) => boolean
  isComplementaryCheckOutCell: (day: App.CalendarDay) => boolean
  isIllegalBundleSelection: (day: App.CalendarDay) => boolean
}

export default function useBundleAndSaveCalendarDayPickingUtils(complementaryBundleState?: BundledOfferState, currentDuration?: number): ReturnArgs {
  const isComplementaryBundleCell = useCallback((day: App.CalendarDay) => {
    if (!complementaryBundleState) {
      return false
    }

    const dayCell = moment(day.checkIn)
    const duration = complementaryBundleState?.duration
    const complementaryCheckOut = complementaryBundleState.checkInDate && duration ? moment(complementaryBundleState.checkInDate).add(duration, 'days') : undefined

    return complementaryBundleState.checkInDate && complementaryCheckOut ? dayCell.isSameOrAfter(complementaryBundleState.checkInDate) && dayCell.isSameOrBefore(complementaryCheckOut) : false
  }, [complementaryBundleState])

  const isComplementaryCheckInCell = useCallback((day: App.CalendarDay) => {
    if (!complementaryBundleState) {
      return false
    }

    return moment(day.checkIn).isSame(complementaryBundleState.checkInDate)
  }, [complementaryBundleState])

  const isComplementaryCheckOutCell = useCallback((day: App.CalendarDay) => {
    if (!complementaryBundleState) {
      return false
    }

    const duration = complementaryBundleState?.duration
    const complementaryCheckOut = complementaryBundleState.checkInDate && duration ? moment(complementaryBundleState.checkInDate).add(duration, 'days') : undefined

    return complementaryCheckOut ? moment(day.checkIn).isSame(complementaryCheckOut) : false
  }, [complementaryBundleState])

  const isIllegalBundleSelection = useCallback((day: App.CalendarDay) => {
    if (!complementaryBundleState) {
      return false
    }

    const dayCell = moment(day.checkIn)
    const duration = complementaryBundleState?.duration
    const complementaryCheckOut = complementaryBundleState.checkInDate && duration ? moment(complementaryBundleState.checkInDate).add(duration, 'days') : undefined

    if (isBundleAndSaveV2Enabled()) {
      if (complementaryCheckOut && currentDuration) {
        const complementaryCheckIn = complementaryBundleState.checkInDate ? moment(complementaryBundleState.checkInDate).subtract(currentDuration, 'days') : undefined
        return dayCell.isBetween(complementaryCheckIn, complementaryCheckOut, 'day', '(]')
      }
      return false
    }
    return complementaryCheckOut ? dayCell.isBefore(complementaryCheckOut) : false
  }, [complementaryBundleState, currentDuration])

  return {
    isComplementaryBundleCell,
    isComplementaryCheckInCell,
    isComplementaryCheckOutCell,
    isIllegalBundleSelection,
  }
}
